"use strict";
(self.webpackChunk_N_E = self.webpackChunk_N_E || []).push([
    [
        99
    ],
    {
        968: (e, t, n)=>{
            n.d(t, {
                b: ()=>c
            });
            var r = n(2115), o = n(3655), a = n(5155), i = r.forwardRef((e, t)=>(0, a.jsx)(o.sG.label, {
                    ...e,
                    ref: t,
                    onMouseDown: (t)=>{
                        var n;
                        t.target.closest("button, input, select, textarea") || (null === (n = e.onMouseDown) || void 0 === n || n.call(e, t), !t.defaultPrevented && t.detail > 1 && t.preventDefault());
                    }
                }));
            i.displayName = "Label";
            var c = i;
        },
        7234: (e, t, n)=>{
            n.d(t, {
                bm: ()=>tt,
                UC: ()=>e7,
                VY: ()=>te,
                hJ: ()=>e6,
                ZL: ()=>e3,
                bL: ()=>e8,
                hE: ()=>e4,
                l9: ()=>e9
            });
            var r, o = n(2115), a = n.t(o, 2), i = n(5185), c = n(6101), u = n(6081), l = n(2712), s = a["useId".toString()] || (()=>void 0), d = 0;
            function f(e) {
                let [t, n] = o.useState(s());
                return (0, l.N)(()=>{
                    e || n((e)=>e ?? String(d++));
                }, [
                    e
                ]), e || (t ? `radix-${t}` : "");
            }
            var p = n(5845), v = n(9178), m = n(3655), h = n(9033), g = n(5155), y = "focusScope.autoFocusOnMount", b = "focusScope.autoFocusOnUnmount", E = {
                bubbles: !1,
                cancelable: !0
            }, w = o.forwardRef((e, t)=>{
                let { loop: n = !1, trapped: r = !1, onMountAutoFocus: a, onUnmountAutoFocus: i, ...u } = e, [l, s] = o.useState(null), d = (0, h.c)(a), f = (0, h.c)(i), p = o.useRef(null), v = (0, c.s)(t, (e)=>s(e)), w = o.useRef({
                    paused: !1,
                    pause () {
                        this.paused = !0;
                    },
                    resume () {
                        this.paused = !1;
                    }
                }).current;
                o.useEffect(()=>{
                    if (r) {
                        let e = function(e) {
                            if (w.paused || !l) return;
                            let t = e.target;
                            l.contains(t) ? p.current = t : S(p.current, {
                                select: !0
                            });
                        }, t = function(e) {
                            if (w.paused || !l) return;
                            let t = e.relatedTarget;
                            null === t || l.contains(t) || S(p.current, {
                                select: !0
                            });
                        };
                        document.addEventListener("focusin", e), document.addEventListener("focusout", t);
                        let n = new MutationObserver(function(e) {
                            if (document.activeElement === document.body) for (let t of e)t.removedNodes.length > 0 && S(l);
                        });
                        return l && n.observe(l, {
                            childList: !0,
                            subtree: !0
                        }), ()=>{
                            document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), n.disconnect();
                        };
                    }
                }, [
                    r,
                    l,
                    w.paused
                ]), o.useEffect(()=>{
                    if (l) {
                        R.add(w);
                        let e = document.activeElement;
                        if (!l.contains(e)) {
                            let t = new CustomEvent(y, E);
                            l.addEventListener(y, d), l.dispatchEvent(t), t.defaultPrevented || (function(e) {
                                let { select: t = !1 } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = document.activeElement;
                                for (let r of e)if (S(r, {
                                    select: t
                                }), document.activeElement !== n) return;
                            }(C(l).filter((e)=>"A" !== e.tagName), {
                                select: !0
                            }), document.activeElement === e && S(l));
                        }
                        return ()=>{
                            l.removeEventListener(y, d), setTimeout(()=>{
                                let t = new CustomEvent(b, E);
                                l.addEventListener(b, f), l.dispatchEvent(t), t.defaultPrevented || S(null != e ? e : document.body, {
                                    select: !0
                                }), l.removeEventListener(b, f), R.remove(w);
                            }, 0);
                        };
                    }
                }, [
                    l,
                    d,
                    f,
                    w
                ]);
                let N = o.useCallback((e)=>{
                    if (!n && !r || w.paused) return;
                    let t = "Tab" === e.key && !e.altKey && !e.ctrlKey && !e.metaKey, o = document.activeElement;
                    if (t && o) {
                        let t = e.currentTarget, [r, a] = function(e) {
                            let t = C(e);
                            return [
                                x(t, e),
                                x(t.reverse(), e)
                            ];
                        }(t);
                        r && a ? e.shiftKey || o !== a ? e.shiftKey && o === r && (e.preventDefault(), n && S(a, {
                            select: !0
                        })) : (e.preventDefault(), n && S(r, {
                            select: !0
                        })) : o === t && e.preventDefault();
                    }
                }, [
                    n,
                    r,
                    w.paused
                ]);
                return (0, g.jsx)(m.sG.div, {
                    tabIndex: -1,
                    ...u,
                    ref: v,
                    onKeyDown: N
                });
            });
            function C(e) {
                let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
                    acceptNode: (e)=>{
                        let t = "INPUT" === e.tagName && "hidden" === e.type;
                        return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
                    }
                });
                for(; n.nextNode();)t.push(n.currentNode);
                return t;
            }
            function x(e, t) {
                for (let n of e)if (!function(e, t) {
                    let { upTo: n } = t;
                    if ("hidden" === getComputedStyle(e).visibility) return !0;
                    for(; e && (void 0 === n || e !== n);){
                        if ("none" === getComputedStyle(e).display) return !0;
                        e = e.parentElement;
                    }
                    return !1;
                }(n, {
                    upTo: t
                })) return n;
            }
            function S(e) {
                let { select: t = !1 } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (e && e.focus) {
                    var n;
                    let r = document.activeElement;
                    e.focus({
                        preventScroll: !0
                    }), e !== r && (n = e) instanceof HTMLInputElement && "select" in n && t && e.select();
                }
            }
            w.displayName = "FocusScope";
            var R = function() {
                let e = [];
                return {
                    add (t) {
                        let n = e[0];
                        t !== n && (null == n || n.pause()), (e = N(e, t)).unshift(t);
                    },
                    remove (t) {
                        var n;
                        null === (n = (e = N(e, t))[0]) || void 0 === n || n.resume();
                    }
                };
            }();
            function N(e, t) {
                let n = [
                    ...e
                ], r = n.indexOf(t);
                return -1 !== r && n.splice(r, 1), n;
            }
            var A = n(4378), D = n(8905), k = 0;
            function M() {
                let e = document.createElement("span");
                return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
            }
            var j = function() {
                return (j = Object.assign || function(e) {
                    for(var t, n = 1, r = arguments.length; n < r; n++)for(var o in t = arguments[n])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                    return e;
                }).apply(this, arguments);
            };
            function I(e, t) {
                var n = {};
                for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && 0 > t.indexOf(r) && (n[r] = e[r]);
                if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)0 > t.indexOf(r[o]) && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
                return n;
            }
            Object.create;
            Object.create;
            var O = ("function" == typeof SuppressedError && SuppressedError, "right-scroll-bar-position"), L = "width-before-scroll-bar";
            function T(e, t) {
                return "function" == typeof e ? e(t) : e && (e.current = t), e;
            }
            var P = "undefined" != typeof window ? o.useLayoutEffect : o.useEffect, F = new WeakMap;
            function W(e) {
                return e;
            }
            var _ = function(e) {
                void 0 === e && (e = {});
                var t, n, r, o, a = (t = null, void 0 === n && (n = W), r = [], o = !1, {
                    read: function() {
                        if (o) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
                        return r.length ? r[r.length - 1] : null;
                    },
                    useMedium: function(e) {
                        var t = n(e, o);
                        return r.push(t), function() {
                            r = r.filter(function(e) {
                                return e !== t;
                            });
                        };
                    },
                    assignSyncMedium: function(e) {
                        for(o = !0; r.length;){
                            var t = r;
                            r = [], t.forEach(e);
                        }
                        r = {
                            push: function(t) {
                                return e(t);
                            },
                            filter: function() {
                                return r;
                            }
                        };
                    },
                    assignMedium: function(e) {
                        o = !0;
                        var t = [];
                        if (r.length) {
                            var n = r;
                            r = [], n.forEach(e), t = r;
                        }
                        var a = function() {
                            var n = t;
                            t = [], n.forEach(e);
                        }, i = function() {
                            return Promise.resolve().then(a);
                        };
                        i(), r = {
                            push: function(e) {
                                t.push(e), i();
                            },
                            filter: function(e) {
                                return t = t.filter(e), r;
                            }
                        };
                    }
                });
                return a.options = j({
                    async: !0,
                    ssr: !1
                }, e), a;
            }(), B = function() {}, K = o.forwardRef(function(e, t) {
                var n, r, a, i, c = o.useRef(null), u = o.useState({
                    onScrollCapture: B,
                    onWheelCapture: B,
                    onTouchMoveCapture: B
                }), l = u[0], s = u[1], d = e.forwardProps, f = e.children, p = e.className, v = e.removeScrollBar, m = e.enabled, h = e.shards, g = e.sideCar, y = e.noIsolation, b = e.inert, E = e.allowPinchZoom, w = e.as, C = e.gapMode, x = I(e, [
                    "forwardProps",
                    "children",
                    "className",
                    "removeScrollBar",
                    "enabled",
                    "shards",
                    "sideCar",
                    "noIsolation",
                    "inert",
                    "allowPinchZoom",
                    "as",
                    "gapMode"
                ]), S = (n = [
                    c,
                    t
                ], r = function(e) {
                    return n.forEach(function(t) {
                        return T(t, e);
                    });
                }, (a = (0, o.useState)(function() {
                    return {
                        value: null,
                        callback: r,
                        facade: {
                            get current () {
                                return a.value;
                            },
                            set current (value){
                                var e = a.value;
                                e !== value && (a.value = value, a.callback(value, e));
                            }
                        }
                    };
                })[0]).callback = r, i = a.facade, P(function() {
                    var e = F.get(i);
                    if (e) {
                        var t = new Set(e), r = new Set(n), o = i.current;
                        t.forEach(function(e) {
                            r.has(e) || T(e, null);
                        }), r.forEach(function(e) {
                            t.has(e) || T(e, o);
                        });
                    }
                    F.set(i, n);
                }, [
                    n
                ]), i), R = j(j({}, x), l);
                return o.createElement(o.Fragment, null, m && o.createElement(g, {
                    sideCar: _,
                    removeScrollBar: v,
                    shards: h,
                    noIsolation: y,
                    inert: b,
                    setCallbacks: s,
                    allowPinchZoom: !!E,
                    lockRef: c,
                    gapMode: C
                }), d ? o.cloneElement(o.Children.only(f), j(j({}, R), {
                    ref: S
                })) : o.createElement(void 0 === w ? "div" : w, j({}, R, {
                    className: p,
                    ref: S
                }), f));
            });
            K.defaultProps = {
                enabled: !0,
                removeScrollBar: !0,
                inert: !1
            }, K.classNames = {
                fullWidth: L,
                zeroRight: O
            };
            var X = function(e) {
                var t = e.sideCar, n = I(e, [
                    "sideCar"
                ]);
                if (!t) throw Error("Sidecar: please provide `sideCar` property to import the right car");
                var r = t.read();
                if (!r) throw Error("Sidecar medium not found");
                return o.createElement(r, j({}, n));
            };
            X.isSideCarExport = !0;
            var Y = function() {
                var e = 0, t = null;
                return {
                    add: function(o) {
                        if (0 == e && (t = function() {
                            if (!document) return null;
                            var e = document.createElement("style");
                            e.type = "text/css";
                            var t = r || n.nc;
                            return t && e.setAttribute("nonce", t), e;
                        }())) {
                            var a, i;
                            (a = t).styleSheet ? a.styleSheet.cssText = o : a.appendChild(document.createTextNode(o)), i = t, (document.head || document.getElementsByTagName("head")[0]).appendChild(i);
                        }
                        e++;
                    },
                    remove: function() {
                        --e || !t || (t.parentNode && t.parentNode.removeChild(t), t = null);
                    }
                };
            }, G = function() {
                var e = Y();
                return function(t, n) {
                    o.useEffect(function() {
                        return e.add(t), function() {
                            e.remove();
                        };
                    }, [
                        t && n
                    ]);
                };
            }, Z = function() {
                var e = G();
                return function(t) {
                    return e(t.styles, t.dynamic), null;
                };
            }, q = {
                left: 0,
                top: 0,
                right: 0,
                gap: 0
            }, H = function(e) {
                return parseInt(e || "", 10) || 0;
            }, U = function(e) {
                var t = window.getComputedStyle(document.body), n = t["padding" === e ? "paddingLeft" : "marginLeft"], r = t["padding" === e ? "paddingTop" : "marginTop"], o = t["padding" === e ? "paddingRight" : "marginRight"];
                return [
                    H(n),
                    H(r),
                    H(o)
                ];
            }, z = function(e) {
                if (void 0 === e && (e = "margin"), "undefined" == typeof window) return q;
                var t = U(e), n = document.documentElement.clientWidth, r = window.innerWidth;
                return {
                    left: t[0],
                    top: t[1],
                    right: t[2],
                    gap: Math.max(0, r - n + t[2] - t[0])
                };
            }, V = Z(), J = "data-scroll-locked", $ = function(e, t, n, r) {
                var o = e.left, a = e.top, i = e.right, c = e.gap;
                return void 0 === n && (n = "margin"), "\n  .".concat("with-scroll-bars-hidden", " {\n   overflow: hidden ").concat(r, ";\n   padding-right: ").concat(c, "px ").concat(r, ";\n  }\n  body[").concat(J, "] {\n    overflow: hidden ").concat(r, ";\n    overscroll-behavior: contain;\n    ").concat([
                    t && "position: relative ".concat(r, ";"),
                    "margin" === n && "\n    padding-left: ".concat(o, "px;\n    padding-top: ").concat(a, "px;\n    padding-right: ").concat(i, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(c, "px ").concat(r, ";\n    "),
                    "padding" === n && "padding-right: ".concat(c, "px ").concat(r, ";")
                ].filter(Boolean).join(""), "\n  }\n  \n  .").concat(O, " {\n    right: ").concat(c, "px ").concat(r, ";\n  }\n  \n  .").concat(L, " {\n    margin-right: ").concat(c, "px ").concat(r, ";\n  }\n  \n  .").concat(O, " .").concat(O, " {\n    right: 0 ").concat(r, ";\n  }\n  \n  .").concat(L, " .").concat(L, " {\n    margin-right: 0 ").concat(r, ";\n  }\n  \n  body[").concat(J, "] {\n    ").concat("--removed-body-scroll-bar-size", ": ").concat(c, "px;\n  }\n");
            }, Q = function() {
                var e = parseInt(document.body.getAttribute(J) || "0", 10);
                return isFinite(e) ? e : 0;
            }, ee = function() {
                o.useEffect(function() {
                    return document.body.setAttribute(J, (Q() + 1).toString()), function() {
                        var e = Q() - 1;
                        e <= 0 ? document.body.removeAttribute(J) : document.body.setAttribute(J, e.toString());
                    };
                }, []);
            }, et = function(e) {
                var t = e.noRelative, n = e.noImportant, r = e.gapMode, a = void 0 === r ? "margin" : r;
                ee();
                var i = o.useMemo(function() {
                    return z(a);
                }, [
                    a
                ]);
                return o.createElement(V, {
                    styles: $(i, !t, a, n ? "" : "!important")
                });
            }, en = !1;
            if ("undefined" != typeof window) try {
                var er = Object.defineProperty({}, "passive", {
                    get: function() {
                        return en = !0, !0;
                    }
                });
                window.addEventListener("test", er, er), window.removeEventListener("test", er, er);
            } catch (e) {
                en = !1;
            }
            var eo = !!en && {
                passive: !1
            }, ea = function(e, t) {
                if (!(e instanceof Element)) return !1;
                var n = window.getComputedStyle(e);
                return "hidden" !== n[t] && (n.overflowY !== n.overflowX || "TEXTAREA" === e.tagName || "visible" !== n[t]);
            }, ei = function(e, t) {
                var n = t.ownerDocument, r = t;
                do {
                    if ("undefined" != typeof ShadowRoot && r instanceof ShadowRoot && (r = r.host), ec(e, r)) {
                        var o = eu(e, r);
                        if (o[1] > o[2]) return !0;
                    }
                    r = r.parentNode;
                }while (r && r !== n.body);
                return !1;
            }, ec = function(e, t) {
                return "v" === e ? ea(t, "overflowY") : ea(t, "overflowX");
            }, eu = function(e, t) {
                return "v" === e ? [
                    t.scrollTop,
                    t.scrollHeight,
                    t.clientHeight
                ] : [
                    t.scrollLeft,
                    t.scrollWidth,
                    t.clientWidth
                ];
            }, el = function(e, t, n, r, o) {
                var a, i = (a = window.getComputedStyle(t).direction, "h" === e && "rtl" === a ? -1 : 1), c = i * r, u = n.target, l = t.contains(u), s = !1, d = c > 0, f = 0, p = 0;
                do {
                    var v = eu(e, u), m = v[0], h = v[1] - v[2] - i * m;
                    (m || h) && ec(e, u) && (f += h, p += m), u = u instanceof ShadowRoot ? u.host : u.parentNode;
                }while (!l && u !== document.body || l && (t.contains(u) || t === u));
                return d && (o && 1 > Math.abs(f) || !o && c > f) ? s = !0 : !d && (o && 1 > Math.abs(p) || !o && -c > p) && (s = !0), s;
            }, es = function(e) {
                return "changedTouches" in e ? [
                    e.changedTouches[0].clientX,
                    e.changedTouches[0].clientY
                ] : [
                    0,
                    0
                ];
            }, ed = function(e) {
                return [
                    e.deltaX,
                    e.deltaY
                ];
            }, ef = function(e) {
                return e && "current" in e ? e.current : e;
            }, ep = 0, ev = [];
            let em = (_.useMedium(function(e) {
                var t = o.useRef([]), n = o.useRef([
                    0,
                    0
                ]), r = o.useRef(), a = o.useState(ep++)[0], i = o.useState(Z)[0], c = o.useRef(e);
                o.useEffect(function() {
                    c.current = e;
                }, [
                    e
                ]), o.useEffect(function() {
                    if (e.inert) {
                        document.body.classList.add("block-interactivity-".concat(a));
                        var t = (function(e, t, n) {
                            if (n || 2 == arguments.length) for(var r, o = 0, a = t.length; o < a; o++)!r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
                            return e.concat(r || Array.prototype.slice.call(t));
                        })([
                            e.lockRef.current
                        ], (e.shards || []).map(ef), !0).filter(Boolean);
                        return t.forEach(function(e) {
                            return e.classList.add("allow-interactivity-".concat(a));
                        }), function() {
                            document.body.classList.remove("block-interactivity-".concat(a)), t.forEach(function(e) {
                                return e.classList.remove("allow-interactivity-".concat(a));
                            });
                        };
                    }
                }, [
                    e.inert,
                    e.lockRef.current,
                    e.shards
                ]);
                var u = o.useCallback(function(e, t) {
                    if ("touches" in e && 2 === e.touches.length || "wheel" === e.type && e.ctrlKey) return !c.current.allowPinchZoom;
                    var o, a = es(e), i = n.current, u = "deltaX" in e ? e.deltaX : i[0] - a[0], l = "deltaY" in e ? e.deltaY : i[1] - a[1], s = e.target, d = Math.abs(u) > Math.abs(l) ? "h" : "v";
                    if ("touches" in e && "h" === d && "range" === s.type) return !1;
                    var f = ei(d, s);
                    if (!f) return !0;
                    if (f ? o = d : (o = "v" === d ? "h" : "v", f = ei(d, s)), !f) return !1;
                    if (!r.current && "changedTouches" in e && (u || l) && (r.current = o), !o) return !0;
                    var p = r.current || o;
                    return el(p, t, e, "h" === p ? u : l, !0);
                }, []), l = o.useCallback(function(e) {
                    if (ev.length && ev[ev.length - 1] === i) {
                        var n = "deltaY" in e ? ed(e) : es(e), r = t.current.filter(function(t) {
                            var r;
                            return t.name === e.type && (t.target === e.target || e.target === t.shadowParent) && (r = t.delta)[0] === n[0] && r[1] === n[1];
                        })[0];
                        if (r && r.should) {
                            e.cancelable && e.preventDefault();
                            return;
                        }
                        if (!r) {
                            var o = (c.current.shards || []).map(ef).filter(Boolean).filter(function(t) {
                                return t.contains(e.target);
                            });
                            (o.length > 0 ? u(e, o[0]) : !c.current.noIsolation) && e.cancelable && e.preventDefault();
                        }
                    }
                }, []), s = o.useCallback(function(e, n, r, o) {
                    var a = {
                        name: e,
                        delta: n,
                        target: r,
                        should: o,
                        shadowParent: function(e) {
                            for(var t = null; null !== e;)e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
                            return t;
                        }(r)
                    };
                    t.current.push(a), setTimeout(function() {
                        t.current = t.current.filter(function(e) {
                            return e !== a;
                        });
                    }, 1);
                }, []), d = o.useCallback(function(e) {
                    n.current = es(e), r.current = void 0;
                }, []), f = o.useCallback(function(t) {
                    s(t.type, ed(t), t.target, u(t, e.lockRef.current));
                }, []), p = o.useCallback(function(t) {
                    s(t.type, es(t), t.target, u(t, e.lockRef.current));
                }, []);
                o.useEffect(function() {
                    return ev.push(i), e.setCallbacks({
                        onScrollCapture: f,
                        onWheelCapture: f,
                        onTouchMoveCapture: p
                    }), document.addEventListener("wheel", l, eo), document.addEventListener("touchmove", l, eo), document.addEventListener("touchstart", d, eo), function() {
                        ev = ev.filter(function(e) {
                            return e !== i;
                        }), document.removeEventListener("wheel", l, eo), document.removeEventListener("touchmove", l, eo), document.removeEventListener("touchstart", d, eo);
                    };
                }, []);
                var v = e.removeScrollBar, m = e.inert;
                return o.createElement(o.Fragment, null, m ? o.createElement(i, {
                    styles: "\n  .block-interactivity-".concat(a, " {pointer-events: none;}\n  .allow-interactivity-").concat(a, " {pointer-events: all;}\n")
                }) : null, v ? o.createElement(et, {
                    gapMode: e.gapMode
                }) : null);
            }), X);
            var eh = o.forwardRef(function(e, t) {
                return o.createElement(K, j({}, e, {
                    ref: t,
                    sideCar: em
                }));
            });
            eh.classNames = K.classNames;
            var eg = function(e) {
                return "undefined" == typeof document ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
            }, ey = new WeakMap, eb = new WeakMap, eE = {}, ew = 0, eC = function(e) {
                return e && (e.host || eC(e.parentNode));
            }, ex = function(e, t, n, r) {
                var o = (Array.isArray(e) ? e : [
                    e
                ]).map(function(e) {
                    if (t.contains(e)) return e;
                    var n = eC(e);
                    return n && t.contains(n) ? n : (console.error("aria-hidden", e, "in not contained inside", t, ". Doing nothing"), null);
                }).filter(function(e) {
                    return !!e;
                });
                eE[n] || (eE[n] = new WeakMap);
                var a = eE[n], i = [], c = new Set, u = new Set(o), l = function(e) {
                    !(!e || c.has(e)) && (c.add(e), l(e.parentNode));
                };
                o.forEach(l);
                var s = function(e) {
                    !(!e || u.has(e)) && Array.prototype.forEach.call(e.children, function(e) {
                        if (c.has(e)) s(e);
                        else try {
                            var t = e.getAttribute(r), o = null !== t && "false" !== t, u = (ey.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
                            ey.set(e, u), a.set(e, l), i.push(e), 1 === u && o && eb.set(e, !0), 1 === l && e.setAttribute(n, "true"), o || e.setAttribute(r, "true");
                        } catch (t) {
                            console.error("aria-hidden: cannot operate on ", e, t);
                        }
                    });
                };
                return s(t), c.clear(), ew++, function() {
                    i.forEach(function(e) {
                        var t = ey.get(e) - 1, o = a.get(e) - 1;
                        ey.set(e, t), a.set(e, o), t || (eb.has(e) || e.removeAttribute(r), eb.delete(e)), o || e.removeAttribute(n);
                    }), --ew || (ey = new WeakMap, ey = new WeakMap, eb = new WeakMap, eE = {});
                };
            }, eS = function(e, t, n) {
                void 0 === n && (n = "data-aria-hidden");
                var r = Array.from(Array.isArray(e) ? e : [
                    e
                ]), o = t || eg(e);
                return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), ex(r, o, n, "aria-hidden")) : function() {
                    return null;
                };
            }, eR = n(9708), eN = "Dialog", [eA, eD] = (0, u.A)(eN), [ek, eM] = eA(eN), ej = (e)=>{
                let { __scopeDialog: t, children: n, open: r, defaultOpen: a, onOpenChange: i, modal: c = !0 } = e, u = o.useRef(null), l = o.useRef(null), [s = !1, d] = (0, p.i)({
                    prop: r,
                    defaultProp: a,
                    onChange: i
                });
                return (0, g.jsx)(ek, {
                    scope: t,
                    triggerRef: u,
                    contentRef: l,
                    contentId: f(),
                    titleId: f(),
                    descriptionId: f(),
                    open: s,
                    onOpenChange: d,
                    onOpenToggle: o.useCallback(()=>d((e)=>!e), [
                        d
                    ]),
                    modal: c,
                    children: n
                });
            };
            ej.displayName = eN;
            var eI = "DialogTrigger", eO = o.forwardRef((e, t)=>{
                let { __scopeDialog: n, ...r } = e, o = eM(eI, n), a = (0, c.s)(t, o.triggerRef);
                return (0, g.jsx)(m.sG.button, {
                    type: "button",
                    "aria-haspopup": "dialog",
                    "aria-expanded": o.open,
                    "aria-controls": o.contentId,
                    "data-state": e$(o.open),
                    ...r,
                    ref: a,
                    onClick: (0, i.m)(e.onClick, o.onOpenToggle)
                });
            });
            eO.displayName = eI;
            var eL = "DialogPortal", [eT, eP] = eA(eL, {
                forceMount: void 0
            }), eF = (e)=>{
                let { __scopeDialog: t, forceMount: n, children: r, container: a } = e, i = eM(eL, t);
                return (0, g.jsx)(eT, {
                    scope: t,
                    forceMount: n,
                    children: o.Children.map(r, (e)=>(0, g.jsx)(D.C, {
                            present: n || i.open,
                            children: (0, g.jsx)(A.Z, {
                                asChild: !0,
                                container: a,
                                children: e
                            })
                        }))
                });
            };
            eF.displayName = eL;
            var eW = "DialogOverlay", e_ = o.forwardRef((e, t)=>{
                let n = eP(eW, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = eM(eW, e.__scopeDialog);
                return a.modal ? (0, g.jsx)(D.C, {
                    present: r || a.open,
                    children: (0, g.jsx)(eB, {
                        ...o,
                        ref: t
                    })
                }) : null;
            });
            e_.displayName = eW;
            var eB = o.forwardRef((e, t)=>{
                let { __scopeDialog: n, ...r } = e, o = eM(eW, n);
                return (0, g.jsx)(eh, {
                    as: eR.DX,
                    allowPinchZoom: !0,
                    shards: [
                        o.contentRef
                    ],
                    children: (0, g.jsx)(m.sG.div, {
                        "data-state": e$(o.open),
                        ...r,
                        ref: t,
                        style: {
                            pointerEvents: "auto",
                            ...r.style
                        }
                    })
                });
            }), eK = "DialogContent", eX = o.forwardRef((e, t)=>{
                let n = eP(eK, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = eM(eK, e.__scopeDialog);
                return (0, g.jsx)(D.C, {
                    present: r || a.open,
                    children: a.modal ? (0, g.jsx)(eY, {
                        ...o,
                        ref: t
                    }) : (0, g.jsx)(eG, {
                        ...o,
                        ref: t
                    })
                });
            });
            eX.displayName = eK;
            var eY = o.forwardRef((e, t)=>{
                let n = eM(eK, e.__scopeDialog), r = o.useRef(null), a = (0, c.s)(t, n.contentRef, r);
                return o.useEffect(()=>{
                    let e = r.current;
                    if (e) return eS(e);
                }, []), (0, g.jsx)(eZ, {
                    ...e,
                    ref: a,
                    trapFocus: n.open,
                    disableOutsidePointerEvents: !0,
                    onCloseAutoFocus: (0, i.m)(e.onCloseAutoFocus, (e)=>{
                        var t;
                        e.preventDefault(), null === (t = n.triggerRef.current) || void 0 === t || t.focus();
                    }),
                    onPointerDownOutside: (0, i.m)(e.onPointerDownOutside, (e)=>{
                        let t = e.detail.originalEvent, n = 0 === t.button && !0 === t.ctrlKey;
                        (2 === t.button || n) && e.preventDefault();
                    }),
                    onFocusOutside: (0, i.m)(e.onFocusOutside, (e)=>e.preventDefault())
                });
            }), eG = o.forwardRef((e, t)=>{
                let n = eM(eK, e.__scopeDialog), r = o.useRef(!1), a = o.useRef(!1);
                return (0, g.jsx)(eZ, {
                    ...e,
                    ref: t,
                    trapFocus: !1,
                    disableOutsidePointerEvents: !1,
                    onCloseAutoFocus: (t)=>{
                        var o, i;
                        null === (o = e.onCloseAutoFocus) || void 0 === o || o.call(e, t), t.defaultPrevented || (r.current || null === (i = n.triggerRef.current) || void 0 === i || i.focus(), t.preventDefault()), r.current = !1, a.current = !1;
                    },
                    onInteractOutside: (t)=>{
                        var o, i;
                        null === (o = e.onInteractOutside) || void 0 === o || o.call(e, t), t.defaultPrevented || (r.current = !0, "pointerdown" !== t.detail.originalEvent.type || (a.current = !0));
                        let c = t.target;
                        (null === (i = n.triggerRef.current) || void 0 === i ? void 0 : i.contains(c)) && t.preventDefault(), "focusin" === t.detail.originalEvent.type && a.current && t.preventDefault();
                    }
                });
            }), eZ = o.forwardRef((e, t)=>{
                let { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: a, onCloseAutoFocus: i, ...u } = e, l = eM(eK, n), s = o.useRef(null), d = (0, c.s)(t, s);
                return o.useEffect(()=>{
                    var e, t;
                    let n = document.querySelectorAll("[data-radix-focus-guard]");
                    return document.body.insertAdjacentElement("afterbegin", null !== (e = n[0]) && void 0 !== e ? e : M()), document.body.insertAdjacentElement("beforeend", null !== (t = n[1]) && void 0 !== t ? t : M()), k++, ()=>{
                        1 === k && document.querySelectorAll("[data-radix-focus-guard]").forEach((e)=>e.remove()), k--;
                    };
                }, []), (0, g.jsxs)(g.Fragment, {
                    children: [
                        (0, g.jsx)(w, {
                            asChild: !0,
                            loop: !0,
                            trapped: r,
                            onMountAutoFocus: a,
                            onUnmountAutoFocus: i,
                            children: (0, g.jsx)(v.qW, {
                                role: "dialog",
                                id: l.contentId,
                                "aria-describedby": l.descriptionId,
                                "aria-labelledby": l.titleId,
                                "data-state": e$(l.open),
                                ...u,
                                ref: d,
                                onDismiss: ()=>l.onOpenChange(!1)
                            })
                        }),
                        (0, g.jsxs)(g.Fragment, {
                            children: [
                                (0, g.jsx)(e5, {
                                    titleId: l.titleId
                                }),
                                (0, g.jsx)(e2, {
                                    contentRef: s,
                                    descriptionId: l.descriptionId
                                })
                            ]
                        })
                    ]
                });
            }), eq = "DialogTitle", eH = o.forwardRef((e, t)=>{
                let { __scopeDialog: n, ...r } = e, o = eM(eq, n);
                return (0, g.jsx)(m.sG.h2, {
                    id: o.titleId,
                    ...r,
                    ref: t
                });
            });
            eH.displayName = eq;
            var eU = "DialogDescription", ez = o.forwardRef((e, t)=>{
                let { __scopeDialog: n, ...r } = e, o = eM(eU, n);
                return (0, g.jsx)(m.sG.p, {
                    id: o.descriptionId,
                    ...r,
                    ref: t
                });
            });
            ez.displayName = eU;
            var eV = "DialogClose", eJ = o.forwardRef((e, t)=>{
                let { __scopeDialog: n, ...r } = e, o = eM(eV, n);
                return (0, g.jsx)(m.sG.button, {
                    type: "button",
                    ...r,
                    ref: t,
                    onClick: (0, i.m)(e.onClick, ()=>o.onOpenChange(!1))
                });
            });
            function e$(e) {
                return e ? "open" : "closed";
            }
            eJ.displayName = eV;
            var eQ = "DialogTitleWarning", [e0, e1] = (0, u.q)(eQ, {
                contentName: eK,
                titleName: eq,
                docsSlug: "dialog"
            }), e5 = (e)=>{
                let { titleId: t } = e, n = e1(eQ), r = "`".concat(n.contentName, "` requires a `").concat(n.titleName, "` for the component to be accessible for screen reader users.\n\nIf you want to hide the `").concat(n.titleName, "`, you can wrap it with our VisuallyHidden component.\n\nFor more information, see https://radix-ui.com/primitives/docs/components/").concat(n.docsSlug);
                return o.useEffect(()=>{
                    t && !document.getElementById(t) && console.error(r);
                }, [
                    r,
                    t
                ]), null;
            }, e2 = (e)=>{
                let { contentRef: t, descriptionId: n } = e, r = e1("DialogDescriptionWarning"), a = "Warning: Missing `Description` or `aria-describedby={undefined}` for {".concat(r.contentName, "}.");
                return o.useEffect(()=>{
                    var e;
                    let r = null === (e = t.current) || void 0 === e ? void 0 : e.getAttribute("aria-describedby");
                    n && r && !document.getElementById(n) && console.warn(a);
                }, [
                    a,
                    t,
                    n
                ]), null;
            }, e8 = ej, e9 = eO, e3 = eF, e6 = e_, e7 = eX, e4 = eH, te = ez, tt = eJ;
        }
    }
]);

//# sourceMappingURL=create.d61d6773.js.map
